module.exports = __webpack_public_path__ + "img/proaju.0763b5dd.png";